import React from "react";

import {
	Checkbox,
	FormControlLabel,
	MenuItem,
	Switch,
	TextField,
	Typography,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";

export const TIMEZONES = [
	"America/Sao_Paulo",
	"America/Manaus",
	"America/Rio_Branco",
	"America/Noronha",
	"America/Cuiaba",
	"Europe/Lisbon",
	"UTC",
];

const WEEK_ORDER = ["1", "2", "3", "4", "5", "6", "0"];

export const defaultBusinessHours = () => ({
	enabled: false,
	timezone: "America/Sao_Paulo",
	days: {
		0: null,
		1: { open: "09:00", close: "18:00" },
		2: { open: "09:00", close: "18:00" },
		3: { open: "09:00", close: "18:00" },
		4: { open: "09:00", close: "18:00" },
		5: { open: "09:00", close: "18:00" },
		6: null,
	},
	holidays: [],
});

/** The API stores the schedule as JSON text. */
export const readBusinessHours = raw => {
	if (!raw) return defaultBusinessHours();
	try {
		const data = typeof raw === "string" ? JSON.parse(raw) : raw;
		return { ...defaultBusinessHours(), ...data };
	} catch (err) {
		return defaultBusinessHours();
	}
};

export const parseHolidays = text =>
	String(text || "")
		.split(/[\s,;]+/)
		.map(item => item.trim())
		.filter(Boolean);

const BusinessHoursFields = ({ value, onChange, holidaysText, onHolidaysText }) => {
	const setDay = (day, patch) => {
		const current = value.days[day];
		onChange({
			...value,
			days: { ...value.days, [day]: patch === null ? null : { ...current, ...patch } },
		});
	};

	return (
		<div style={{ marginTop: 16 }}>
			<FormControlLabel
				control={
					<Switch
						color="primary"
						checked={!!value.enabled}
						onChange={e => onChange({ ...value, enabled: e.target.checked })}
					/>
				}
				label={i18n.t("whatsappModal.hours.enabled")}
			/>
			{value.enabled && (
				<>
					<Typography variant="caption" color="textSecondary" component="p">
						{i18n.t("whatsappModal.hours.help")}
					</Typography>
					<TextField
						select
						fullWidth
						variant="outlined"
						margin="dense"
						label={i18n.t("whatsappModal.hours.timezone")}
						value={value.timezone}
						onChange={e => onChange({ ...value, timezone: e.target.value })}
					>
						{(TIMEZONES.includes(value.timezone)
							? TIMEZONES
							: [value.timezone, ...TIMEZONES]
						).map(tz => (
							<MenuItem key={tz} value={tz}>
								{tz}
							</MenuItem>
						))}
					</TextField>
					{WEEK_ORDER.map(day => {
						const win = value.days[day];
						return (
							<div
								key={day}
								style={{ display: "flex", alignItems: "center", gap: 8 }}
							>
								<FormControlLabel
									style={{ width: 150, marginRight: 0 }}
									control={
										<Checkbox
											color="primary"
											checked={!!win}
											onChange={e =>
												setDay(
													day,
													e.target.checked
														? { open: "09:00", close: "18:00" }
														: null
												)
											}
										/>
									}
									label={i18n.t(`whatsappModal.hours.days.${day}`)}
								/>
								{win ? (
									<>
										<TextField
											type="time"
											size="small"
											variant="outlined"
											margin="dense"
											value={win.open}
											onChange={e => setDay(day, { open: e.target.value })}
											inputProps={{ step: 300 }}
										/>
										<span>–</span>
										<TextField
											type="time"
											size="small"
											variant="outlined"
											margin="dense"
											value={win.close}
											onChange={e => setDay(day, { close: e.target.value })}
											inputProps={{ step: 300 }}
										/>
									</>
								) : (
									<Typography variant="body2" color="textSecondary">
										{i18n.t("whatsappModal.hours.closed")}
									</Typography>
								)}
							</div>
						);
					})}
					<TextField
						multiline
						rows={3}
						fullWidth
						variant="outlined"
						margin="dense"
						label={i18n.t("whatsappModal.hours.holidays")}
						helperText={i18n.t("whatsappModal.hours.holidaysHelp")}
						value={holidaysText}
						onChange={e => onHolidaysText(e.target.value)}
					/>
				</>
			)}
		</div>
	);
};

export default BusinessHoursFields;
